

// Filters.js
import Vue from 'vue';
import moment from 'moment-timezone';

import i18n from './i18n'
import { getAuth } from '@/services/authService'

let timezone = null
const _auth = getAuth();

let name = 'TMT[lang]';
const locale = (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
if(_auth && _auth.user && _auth.user.timezone){
    const tz = _auth.user.timezone
    timezone = typeof tz === 'string' ? tz : (tz && tz.name) || 'America/Sao_Paulo'

}
Vue.filter('percentDiscount', value => {
    if(!value) return ''
    // if(value && value.includes(',')){
    //     value = value.split(',')[0]
    // }
    if (value > 0 && value < 1){
        return '< 1'
    }
    else{
        return Math.round(value)
    }
})
Vue.filter('bytes', value => {
    const const_term = 1024;

    // Convert the values and concatenate
    // the appropriate unit
    if (value < const_term ** 2) {
        return (value / const_term).toFixed(3) + 'KB';

    } else if (value < const_term ** 3) {
        return (value / const_term ** 2).toFixed(3) + 'MB';

    } else {
        return (value / const_term ** 3).toFixed(3) + 'GB';

    }
});
Vue.filter('bytesValue', value => {
    const const_term = 1024;

    // Convert the values and concatenate
    // the appropriate unit
    if (value < const_term ** 2) {
        return (value / const_term).toFixed(3)
    } else if (value < const_term ** 3) {
        return (value / const_term ** 2).toFixed(3)
    } else {
        return (value / const_term ** 3).toFixed(3)
    }
});
Vue.filter('bytesLabel', value => {
    const const_term = 1024;

    // Convert the values and concatenate
    // the appropriate unit
    if (value < const_term ** 2) {
        return 'KB'
    } else if (value < const_term ** 3) {
        return 'MB'
    } else {
        return 'GB'
    }
});
Vue.filter('dateCompact', value => {
    return moment(value).format('D/M/YY')
});
Vue.filter('dateYear', value => {
    return moment(value).format('YYYY')
});
Vue.filter('monthYear', value => {
    return moment(value,'YYYY-MM').locale('pt-br').format('MMM/YYYY')
})
Vue.filter('dateMonth', value => {
    console.log('dateMonth', value)
    const r = moment(value, 'YYYY-MM-D').locale(i18n.locale).format('MMMM')
    console.log('R', r)
    return r
});

Vue.filter('dateTimeTz', (value, tz) => {
    // const f = moment(value).format()
    // console.log('date from value only', f)
    // const a = moment.tz(value, tz);
    // console.log('date with tz ' + tz , a.format())
    const utc = moment.utc(value)
    // return moment(utc).format('lll')
    return utc.locale(i18n.locale).local().format('lll')

    // const b=  moment(utc).locale(i18n.locale).add(cur,'hours').format('lll')
    // console.log('date to', b)
    // return b
});

Vue.filter('date', value => {
    if(!value) return ''
    return moment(value).locale(i18n.locale).format('L')
});
Vue.filter('dateTimeS', value => {
    return `${moment(value).locale(i18n.locale).format('L')} ${moment(value).locale(i18n.locale).format('LT')}`
});
Vue.filter('dateTime', value => {
    if(typeof value == 'undefined') return ''
    console.log('dateTime value', value)
    moment.tz(value, timezone).locale(locale).format('lll')
    return moment(value).locale(i18n.locale).format('lll')
});
Vue.filter('dateTimeDefault', value => {
    if(typeof value == 'undefined') return ''
    moment.tz(value, timezone).locale(locale).format('lll')
    return moment(value).locale(i18n.locale).format('lll')
});
Vue.filter('dateTimeX', value => {
    moment.tz(value, timezone).locale(locale).format('lll')
    return moment(value).locale(i18n.locale).format('x')
});
Vue.filter('dateTimeFromUTC', value => {
    const x = moment.utc(value, 'YYYY-MM-DD hh:mm:ii').toDate();

    var stillUtc = moment.utc(x).toDate();
    const y = moment(stillUtc).local()
    // moment.tz(y, timezone).locale(locale).format('lll')
    return moment.tz(y, timezone).locale(i18n.locale).format('lll')

    // console.log('X time', x)
    // const y =  x.locale(i18n.locale)
    // console.log('Y', y)
    // return y.format('lll')
});

Vue.filter('dateTimeSampleFromUTC', value => {
    const x = moment.utc(value, (value.includes('-') ? 'YYYY-MM-DD hh:mm:ii' : 'DD/MM/YYYY hh:mm:ii')).toDate();

    var stillUtc = moment.utc(x).toDate();
    const y = moment(stillUtc).local()
    // moment.tz(y, timezone).locale(locale).format('lll')
    return moment.tz(y, timezone).locale(i18n.locale).format('lll')

    // console.log('X time', x)
    // const y =  x.locale(i18n.locale)
    // console.log('Y', y)
    // return y.format('lll')
});


Vue.filter('dateFromX', value => {
    return moment(value, 'x').locale(i18n.locale).format('L')
});

Vue.filter('dateFromX', value => {
    return moment(value, 'x').locale(i18n.locale).format('L')
});


Vue.filter('dateDay', value => {
    console.log('Value', value)
    return moment(value, 'YYYY-MM-D').format('D')
})
Vue.filter('weekDay', value => {
    return moment(value, 'YYYY-MM-D').format('dd')
})

Vue.filter('document', value => {
    if(value.length == 14){
       return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    }
})

Vue.filter('asuFormat', value => {
    if(!value) return ''
    return value.print.replace('type', value?.type).replace('metric', value?.metric).replace('value', value?.value)
})


 Vue.filter('location', (value) => {
    let result = []
    if (typeof value != 'undefined' && value && typeof value.original != 'undefined') {
        if (typeof value.original.street != 'undefined' && value.original.street) result.push(value.original.street)
        if (typeof value.original.number != 'undefined' && value.original.number) result.push(value.original.number)
        if (result.length > 1) {
            result = [result.join(', ')];
        }
        if (typeof value.original.region != 'undefined') {
            let region = value.original.region
            if (typeof region.city != 'undefined' && region.city && typeof region.city.long_name != 'undefined' && region.city && region.city.long_name) result.push(region.city.long_name)
            if (typeof region.state != 'undefined' && region.state && typeof region.state.short_name != 'undefined' && region.state && region.state.short_name) result.push(region.state.short_name)
            result = result.join(' - ');
            if (typeof region.country.long_name != 'undefined' && result.length == 0 && region.country && region.country.long_name) {
                result = region.country.long_name
            }
        }
    }
    return result;
})

Vue.filter('asuBuckets', value => {
    const res = []
    if(!value) return ""
    value.forEach((bucket) => {
        res.push(`${bucket.title}: ${bucket.name}`)
    })
    return res.join(', ')
})

Vue.filter('asuPeriodicity', value => {
    switch(value.type){
        case 'M':
            if(value.value == 1)
                return 'Mensal'
            if(value.value == 2)
                return 'Bimestral'
            if(value.value == 3)
                return 'Trimestral'
            if(value.value == 6)
                return 'Semestral'
            if(value.value == 12)
                return 'Anual'
        case 'W':
            if(value.value == 1)
                return 'Semanal'
            if(value.value == 2)
                return 'Quinzenal'
        case 'D':
            if(value.value == 1)
                return 'Diário'
            return `${value.value} dias`

        return `${value.type} ${value.value}`
            

    }
})
